import React from "react";
import { useNavigate } from "react-router-dom";
 
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      background: 'rgba(0,0,0,0.7)',
      color: '#fff',
      padding: '40px 16px'
    }}>
      <h1 style={{ fontSize: '7rem', margin: 0, color: '#6941E6', fontWeight: 900 }}>404</h1>
      <h2 style={{ fontSize: '2.2rem', margin: '16px 0 8px 0' }}>Page Not Found</h2>
      <p style={{ fontSize: '1.2rem', marginBottom: 32 }}>
        Sorry, the page you are looking for does not exist.<br />
        You can always go back to the homepage.
      </p>
      <button
        onClick={() => navigate('/')}
        style={{
          background: '#6941E6',
          color: '#fff',
          border: 'none',
          borderRadius: 32,
          padding: '14px 36px',
          fontSize: '1.1rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 2px 12px #6941E6cc',
          transition: 'background 0.2s, color 0.2s',
        }}
        onMouseOver={e => e.currentTarget.style.background = '#6941E6'}
        onMouseOut={e => e.currentTarget.style.background = '#6941E6'}
      >
        Go to Home
      </button>
    </div>
  );
};
 
export default NotFound;